import { KeyboardBackspace } from '@mui/icons-material'
import { Button, Grid, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

type Props = {
  fullName: string
}

export default function TopSection(props: Props) {
  const theme = useTheme()
  const texts = useTranslation(['common', 'traineeDetails']).t
  const navigate = useNavigate()

  return (
    <Grid
      sx={{
        [theme.breakpoints.up('md')]: {
          paddingTop: '2rem'
        },
        [theme.breakpoints.down('md')]: {
          paddingTop: '1.5rem'
        },
        [theme.breakpoints.down('sm')]: {
          paddingTop: '1.5rem'
        }
      }}
    >
      <Button 
        variant='text'
        onClick={() => { navigate(-1)}}
      >
        <Grid
          container
          alignItems='center'
          gap='.5rem'
        >
          <KeyboardBackspace sx={{ marginTop: '-.125rem'}} />
          {texts('common:back')}
        </Grid>
      </Button>
      <Grid
        container
        flexDirection='column'
        marginTop='1rem'
        flexWrap='nowrap'
        sx={{
          [theme.breakpoints.up('md')]: {
            gap: '.5rem'
          },
          [theme.breakpoints.down('md')]: {
            gap: '.5rem'
          },
          [theme.breakpoints.down('sm')]: {
            gap: '.25rem'
          }
        }}
      >
        <Typography variant='h2'>
          {texts('traineeDetails:title')}
        </Typography>
        <Typography 
          variant='subtitle1'
          fontWeight={700}
        >
          {props.fullName}
        </Typography>
      </Grid>
    </Grid>
  )
}